import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/auth/sign-in`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signIn = {
  post: apiPathFunc(pathBase),
};
